const getters = {
  projectId: state => state.common.projectId,
  projectInfo: state => state.common.projectInfo,
  userInfo: state => state.common.userInfo,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  permissionList: state => state.common.permissionList,
  isCollapse: state => state.common.isCollapse,
  accident: state => state.common.accident,
  chemicalList: state => state.common.chemicalList,
  alarmData: state => state.common.alarmData,
  routeTab: state => state.common.routeTab,
  isAddCompany: state => state.common.isAddCompany,
  isProjectUser: state => state.common.isProjectUser,
  userId: state => state.common.userId
}
export default getters
